<template>
  <div class="library-right-click-box-background"
       v-if="$store.state.libraryRightClickOverlay.visible && $store.state.libraryRightClickOverlayActions"
       @click="closeRightClick" />
  <div class="library-right-click-box"
       id="library-right-click-box"
       :style="{
         left:$store.state.libraryRightClickOverlay.positionX+'px',
         top:$store.state.libraryRightClickOverlay.positionY+'px',
         display:$store.state.libraryRightClickOverlay.visible?'block':'none',
       }"
       v-if="Array.isArray($store.state.libraryRightClickOverlayActions)"
  >
    <template v-for="action in $store.state.libraryRightClickOverlayActions">
      <div :class="'library-right-click-box-action '+((action.disabled)?'disabled':'')"
           @click="() => handleAction(action)"
      >
        {{ action.title }}
      </div>
    </template>
  </div>
</template>

<style scoped>
.library-right-click-box {
  position: fixed;
  background-color: var(--son-dunkelgrau);
  color: white;
  padding: 20px;
  top: 0;
  left: 0;
  z-index: 50005;
}

.library-right-click-box-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50000;
}

.library-right-click-box-action {
  cursor: pointer;
}

.library-right-click-box-action.disabled {
  cursor: not-allowed;
  color: var(--disabled-grey);
}
</style>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    closeRightClick() {
      this.$store.state.libraryRightClickOverlay.visible = false;
    },
    handleAction(action) {
      if(action.disabled) {
        return;
      }
      this.closeRightClick();
      action.action(this.$store.state.libraryRightClickOverlay.id);
    }
  }
}
</script>